// ADV-1132 / ADR-0045: in-flight payload for the media-finalize Cloudflare
// Queue. The producer is the Validate stage (ADV-1131); the consumer is
// `apps/import-pipeline/src/finalize-consumer.ts`. Parsed defensively at the
// consumer boundary — bad shapes route to media-finalize-dlq via throw.

import { z } from "zod";
import { mediaSubjectEntityTypes } from "./media.schema";
import { TraceCarrierSchema } from "./trace-carrier.schema";

const UuidSchema = z.string().uuid();

export const FinalizeSubjectSchema = z.object({
  entity_type: z.enum(mediaSubjectEntityTypes).describe("Entity Type"),
  entity_id: UuidSchema.describe("Entity Id"),
});
export type FinalizeSubject = z.infer<typeof FinalizeSubjectSchema>;

export const FinalizeAttachmentSchema = z.object({
  communication_id: UuidSchema.describe("Communication Id"),
  ordinal: z.number().int().min(0).describe("Ordinal"),
  caption: z.string().optional().describe("Caption"),
});
export type FinalizeAttachment = z.infer<typeof FinalizeAttachmentSchema>;

export const FinalizeMessageSchema = z.object({
  media_item_id: UuidSchema.describe("Media Item Id"),
  submission_id: UuidSchema.describe("Submission Id"),
  business_id: UuidSchema.describe("Business Id"),
  account_id: UuidSchema.optional().describe("Account Id"),
  import_job_id: UuidSchema.describe("Import Job Id"),
  staging_key: z.string().min(1).describe("Staging Key"),
  content_type: z.string().min(1).describe("Content Type"),
  content_dedup_of: UuidSchema.nullable()
    .optional()
    .describe("Content Dedup Of"),
  subjects: z.array(FinalizeSubjectSchema).default([]).describe("Subjects"),
  attachment: FinalizeAttachmentSchema.optional().describe("Attachment"),
  // ADV-1202 / ADR-0053: W3C trace context propagated from the Validate stage.
  _trace: TraceCarrierSchema.optional().describe("Trace"),
});
export type FinalizeMessage = z.infer<typeof FinalizeMessageSchema>;
